import mutations from "./mutations"; 
import actions from "./actions";
import state from "./state";
import getters from "./getters";
const auth = {
  namespaced: true,
  mutations,
  actions,
  state,
  getters
}

export default auth;